import { AxiosResponse } from 'axios';
import {
  IGetAdminAwardsParams,
  IGetAdminAwardsResponse,
  IGetAwardTypesResponse,
  ICreateAwardParams,
  IEditAwardParams,
  IMutationResponse,
} from '../../../interface/classveew-admin/admin-award.interface';
import { adminInstance } from '../../api';

export interface IUploadAwardMediaResponse {
  status: number;
  message: string;
  responseArray: Array<{
    mediaFiles: Array<{
      id: string;
      assert_url?: string;
      [key: string]: any;
    }>;
  }>;
}

export const getAdminAwards = async (
  params: IGetAdminAwardsParams,
): Promise<AxiosResponse<IGetAdminAwardsResponse>> => {
  const response = await adminInstance.get<IGetAdminAwardsResponse>('/awards', {
    params,
  });
  return response;
};

export const getAwardTypes = async (): Promise<AxiosResponse<IGetAwardTypesResponse>> => {
  const response = await adminInstance.get<IGetAwardTypesResponse>('/awards/types');
  return response;
};

export const createAdminAward = async (
  data: ICreateAwardParams,
): Promise<AxiosResponse<IMutationResponse>> => {
  const response = await adminInstance.post<IMutationResponse>('/awards', data);
  return response;
};

export const editAdminAward = async (
  id: string,
  data: IEditAwardParams,
): Promise<AxiosResponse<IMutationResponse>> => {
  const response = await adminInstance.put<IMutationResponse>(`/awards/${id}`, data);
  return response;
};

export const deleteAdminAward = async (id: string): Promise<AxiosResponse<IMutationResponse>> => {
  const response = await adminInstance.delete<IMutationResponse>(`/awards/${id}`);
  return response;
};

export const toggleAdminAward = async (id: string): Promise<AxiosResponse<IMutationResponse>> => {
  const response = await adminInstance.patch<IMutationResponse>(`/awards/${id}/toggle`);
  return response;
};

/**
 * Upload media file for award
 * Handles multipart/form-data upload to /v2/file endpoint
 * @param formData - FormData containing the file to upload
 * @returns Promise with upload response containing asset IDs
 */
export const uploadAwardMedia = async (
  formData: FormData,
): Promise<AxiosResponse<IUploadAwardMediaResponse>> => {
  const response = await adminInstance.post<IUploadAwardMediaResponse>('/file', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response;
};
